<div class="card rubbl-card" rt="rental-details-card">
  <div class="card-body">
    <div class="row">
      <div class="col-md-3">
        <label>Jobsite location</label>
        <div class="font-weight-light address" [innerHtml]="rental.dropoffLocation | location: 'full':true"></div>
      </div>
      <div class="col-md-3 mt-3 mt-md-0">
        <div class="d-flex align-items-center">
          <label class="mr-auto">Jobsite contact</label>
        </div>
        <div class="font-weight-light">
          <div>{{ rental.contacts[0].name }}</div>
          <div class="mt-1">{{ rental.contacts[0].phoneNumber }}</div>
          <div class="mt-1">{{ rental.contacts[0].email }}</div>
        </div>
      </div>
      <div class="col-md-3 mt-3 mt-md-0">
        <label>Job or PO Number</label>
        <div class="font-weight-light">{{ firstItem?.poJobNumber || "-" }}</div>
      </div>
      <div class="col-md-3 mt-3 mt-md-0" *ngIf="cart?.metadata?.terms">
        <label>Terms Accepted</label>
        <div class="font-weight-light">{{ rental.createdDateTime | date: "medium" }}</div>
        <a [routerLink]="['contract']">View contract</a>
      </div>
    </div>
  </div>
</div>
